import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import { initTranslations } from './app/core/utils/translations';

import { App } from './app';
import { sentrySetup } from './app/utils/sentry';

sentrySetup();

async function bootstrap() {
  try {
    await initTranslations({
      ns: [],
      backend: {
        loadPath: `${process.env.MIX_ADMIN_SYSTEM_URL}/api/translations/{{lng}}/{{ns}}`,
      },
      supportedLngs: ['de'],
      defaultLanguage: document.getElementsByTagName('html')[0].lang || 'de',
      fallbackLng: 'de',
    });
  } catch (error) {
    console.error(`Error while initializing translations: ${error}`);
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => console.log(registration))
      .catch((error) => console.error(error));
  }

  createRoot(document.getElementById('root')).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  );
}
bootstrap();
